import { Box, colors, Divider, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { OutlineInput } from "./OutlineInput";
import { ReactComponent as TrashIcon } from "assets/icons/trash.svg";

const renderData = (keyName, data) => {
  if (data) {
    const ipData = Object.entries(data).find(([key, value]) => key === keyName);
    return ipData && ipData[1];
  }
};

export const AllowIp = ({ keyName, ipData, isDeleteIcon = false, dyanamicWidth = "100%", handleDelete }) => {
  const fromIPData = renderData("fromIp", ipData);
  const toIPData = renderData("toIp", ipData);

  return (
    <Grid key={keyName} container width={dyanamicWidth} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
      <OutlineInput
        key={fromIPData?.key}
        item={{
          title: fromIPData?.title,
          id: fromIPData?.id,
          name: fromIPData?.name,
          type: fromIPData?.type,
          placeholder: fromIPData?.placeholder,
        }}
        onChange={fromIPData?.onChange}
        value={fromIPData?.value}
        // isEditUser={id ? true : false}
        styleFormLable={
          fromIPData?.styleFormLable || {
            fontFamily: "Karla",
          }
        }
        gridStyle={fromIPData?.gridStyle || { xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}
        readOnly={fromIPData?.readOnly === "false" ? false : true}
        isEditUser={fromIPData?.isEditUser}
      />
      <OutlineInput
        key={toIPData?.key}
        item={{
          title: toIPData?.title,
          id: toIPData?.id,
          name: toIPData?.name,
          type: toIPData?.type,
          placeholder: toIPData?.placeholder,
        }}
        onChange={toIPData?.onChange}
        value={toIPData?.value}
        // isEditUser={id ? true : false}
        styleFormLable={
          toIPData?.styleFormLable || {
            fontFamily: "Karla",
          }
        }
        gridStyle={toIPData?.gridStyle || { xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}
        readOnly={toIPData?.readOnly === "false" ? false : true}
        isEditUser={toIPData?.isEditUser}
      />
      {isDeleteIcon && (
        <Grid item xs={12} sm={12} md={1} lg={1} xl={1} sx={{ paddingTop: "40px" }}>
          <IconButton
            disableFocusRipple
            disableRipple
            // sx={{ padding: "0px" }}
            onClick={handleDelete}
          >
            <TrashIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};
